module.exports = __webpack_public_path__ + "img/banner1.6442ff0d.png";